import { ConfigProvider } from "antd";
import ReactDOM from "react-dom/client";
import { scan } from "react-scan";

// Global Chart.js registration - MUST be before any Chart.js components
import {
	BarController,
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LineController,
	LineElement,
	LinearScale,
	PointElement,
	Title,
	Tooltip,
} from "chart.js";

// Register all Chart.js components globally to prevent deployment issues
ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineController,
	LineElement,
	BarController,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

import { App } from "./App";
import defaultAntDTheme from "./assets/theme/antd.default.theme.json";
import { initSentry } from "./sentry";
import { initializeCacheManager } from "./utils/cache-manager";
const antdThemeDefault = defaultAntDTheme;
import "./index.scss";

if (typeof window !== "undefined") {
	scan({
		enabled: import.meta.env.VITE_REACT_SCAN_ENABLED || false,
		log: import.meta.env.VITE_REACT_SCAN_ENABLED || false, // logs render info to console (default: false)
	});
}

// Retrieve the root DOM element
const rootElement = document.getElementById("root");

// Ensure the root element exists
if (!rootElement) {
	throw new Error(
		'Failed to find the root element. Please ensure there is an element with id "root" in your index.html.',
	);
}

// Create a React root
const root = ReactDOM.createRoot(rootElement);

// Determine if the current environment is development
const isDevelopment = import.meta.env.VITE_ENV !== "production";
console.log(
	"Is Development:",
	isDevelopment,
	"Environment:",
	import.meta.env.VITE_ENV,
);

try {
	initSentry();
} catch (error) {
	console.error(error);
}

// Initialize cache manager (clears caches if version changed)
(async () => {
	try {
		const versionChanged = initializeCacheManager();

		// Setup version monitoring to detect midday deployments
		// Only if version didn't just change (no need to check immediately after reload)
		if (!versionChanged) {
			const { setupVersionMonitoring } = await import("@/utils/cache-manager");
			setupVersionMonitoring();
		}
	} catch (error) {
		console.error("Cache manager initialization error:", error);
	}
})();

// Render the React application
// Note: StrictMode disabled to prevent double-rendering and duplicate API calls in development
root.render(
	<ConfigProvider theme={{ ...antdThemeDefault }}>
		<App />
	</ConfigProvider>,
);
